import { CSSProperties } from 'react';

export const AddMaintenanceImageIconUrl =
  'https://imgdrop.imgix.net/1dde8dbf19a646bdab877766d0d424a4.svg';

export const MaintenanceImageIconUrl =
  'https://imgdrop.imgix.net/a002164d6b644bdb8323724bbb0e4a31.svg';

export const CloseXIconUrl = 'https://imgdrop.imgix.net/60f93110f41f4eb183df5774e492c9f4.svg';

export const NotFoundIconUrl = 'https://imgdrop.imgix.net/e984ae4e2d9f459bb062f6a8eb2aceeb.svg';

export const LeftChevronButtonUrl =
  'https://imgdrop.imgix.net/658e7c94f7504bbbb571f64dc35f6edc.svg';

export const RightChevronButtonUrl =
  'https://imgdrop.imgix.net/f17b105e147c43e2baf5d7cef3643817.svg';

export const PlusIconUrl = 'https://imgdrop.imgix.net/6b47fe3e7928404dba09e78d2662f3eb.svg';

export const EmptyIconSVG = ({ emptyIconStyle }: { emptyIconStyle: CSSProperties }) => {
  return (
    <svg style={emptyIconStyle} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="40" height="40" rx="2" fill="#C4C4C4" />
      <path
        d="M29.5278 29C30.7465 29 31.7778 28.0156 31.7778 26.75V13.25C31.7778 12.0312 30.7465 11 29.5278 11H10.0278C8.76215 11 7.77777 12.0312 7.77777 13.25V26.75C7.77777 28.0156 8.76215 29 10.0278 29H29.5278ZM13.0278 13.625C14.434 13.625 15.6528 14.8438 15.6528 16.25C15.6528 17.7031 14.434 18.875 13.0278 18.875C11.5746 18.875 10.4028 17.7031 10.4028 16.25C10.4028 14.8438 11.5746 13.625 13.0278 13.625ZM10.7778 26V23.75L14.1059 20.4219C14.3403 20.1875 14.6684 20.1875 14.9028 20.4219L17.5278 23L23.8559 16.6719C24.0903 16.4375 24.4184 16.4375 24.6528 16.6719L28.7778 20.75V26H10.7778Z"
        fill="#DEDEDE"
      />
    </svg>
  );
};

export const GreenCheckCircleIcon =
  'https://imgdrop.imgix.net/43c1822259c14f989942a024117a864d.svg';

export const TrashCanCircleIcon = 'https://imgdrop.imgix.net/2023-02-1676929643698-04983.svg';
